import { useIntl } from 'react-intl';

import { useMountToHtmlElement } from '@post-office/components--post-office-team';

import { Text } from '@atlaskit/primitives/compiled';

import { messages } from './messages';

import { type JSX } from 'react/jsx-runtime';

import { SpotlightStepCount } from '@atlaskit/spotlight/step-count';

import { SpotlightPrimaryAction } from '@atlaskit/spotlight/primary-action';

import { SpotlightFooter } from '@atlaskit/spotlight/footer';

import { SpotlightCard } from '@atlaskit/spotlight/card';

import { SpotlightBody } from '@atlaskit/spotlight/body';

import { SpotlightActions } from '@atlaskit/spotlight/actions';

import { PopoverTarget } from '@atlaskit/spotlight/popover-target';

import { PopoverProvider } from '@atlaskit/spotlight/popover-provider';

import { PopoverContent } from '@atlaskit/spotlight/popover-content';

const MORE_ACTIONS_SPOTLIGHT_TARGET =
	'[data-testid="project-issue-navigator.ui.page-actions.meatball-menu-anchor"]';

export const MoreActionsSpotlight = ({
	onFinish,
	isVisible = true,
}: {
	onFinish: (isTourCompleted?: boolean) => void;
	isVisible?: boolean;
}): JSX.Element => {
	const { formatMessage } = useIntl();
	const renderInline = useMountToHtmlElement({
		selectors: MORE_ACTIONS_SPOTLIGHT_TARGET,
		as: 'portal',
		position: 'inside',
	});

	return (
		<div>
			{renderInline(
				<PopoverProvider>
					<PopoverTarget>
						{/* Dummy target mounted inside the real target element */}
						<div />
					</PopoverTarget>
					<PopoverContent
						dismiss={() => onFinish()}
						placement="left-start"
						isVisible={isVisible}
						testId="more-actions-spotlight--dialog"
					>
						<SpotlightCard>
							<SpotlightBody>
								<Text>{formatMessage(messages.moreActionsSpotlightMessage)}</Text>
							</SpotlightBody>
							<SpotlightFooter>
								<SpotlightStepCount>2/2</SpotlightStepCount>
								<SpotlightActions>
									<SpotlightPrimaryAction onClick={() => onFinish(true)}>
										{formatMessage(messages.okButton)}
									</SpotlightPrimaryAction>
								</SpotlightActions>
							</SpotlightFooter>
						</SpotlightCard>
					</PopoverContent>
				</PopoverProvider>,
			)}
		</div>
	);
};
